import moment from 'moment'
import type { View } from 'react-big-calendar'

export const CALENDAR_BUFFER_DAYS = 60

/** Returns the start/end of the visible range for a given date and calendar view. */
export function getViewRange(d: Date, v: View): { start: Date; end: Date } {
  const start = new Date(d)
  const end = new Date(d)
  switch (v) {
    case 'week': {
      const dow = start.getDay()
      start.setDate(start.getDate() - dow)
      start.setHours(0, 0, 0, 0)
      end.setDate(end.getDate() + (6 - dow))
      end.setHours(23, 59, 59, 999)
      break
    }
    case 'day':
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      break
    default: // month
      start.setDate(1)
      start.setHours(0, 0, 0, 0)
      end.setMonth(end.getMonth() + 1, 0)
      end.setHours(23, 59, 59, 999)
  }
  return { start, end }
}

export const handleCalendarNavigate = (date: Date, action: string, timeSpan: 'day' | 'week' | 'month') => {
  switch (action) {
    case 'PREV':
      return moment(date).subtract(1, timeSpan).toDate()
    case 'NEXT':
      return moment(date).add(1, timeSpan).toDate()
    default:
      return date
  }
}

export const getMapTitle = (date: Date, view: 'day' | 'week' | 'month' = 'month') => {
  const m = moment(date)
  if (view === 'day') {
    return m.format('dddd MMMM D, YYYY')
  }
  if (view === 'week') {
    const start = m.clone().startOf('week')
    const end = m.clone().endOf('week')
    if (start.month() === end.month()) {
      return `${start.format('MMMM DD')} - ${end.format('DD')}`
    } else {
      return `${start.format('MMMM DD')} - ${end.format('MMMM DD')}`
    }
  }
  return m.format('MMMM YYYY')
}

export function getEventTimes(date: Date | moment.Moment, view: View, timezone: string) {
  const momentDate = moment(date).tz(timezone)
  if (view === 'month') {
    const now = moment()
    const nextHour = now.clone().add(1, 'hour').startOf('hour')
    momentDate.set({ hour: nextHour.hour(), minute: 0, second: 0, millisecond: 0 })
    return {
      start: momentDate.toDate(),
      end: momentDate.clone().add(1, 'hour').toDate()
    }
  } else {
    return {
      start: momentDate.toDate(),
      end: momentDate.clone().add(1, 'hour').toDate()
    }
  }
}
